<template>
  <div class="template-container">
    <div class="brand">
      <a id="home"></a>
        <Menu></Menu>
        <div class="container">
            <div class="brand__body">
                <h1 class="brand__title">We work with traffic for your convenience</h1>
                <p class="brand__desc">AdOperator: performance oriented DSP.</p>
                <div class="brand__controls">
                    <router-link to="/signup" class="button button--rounded button--wshadow button--secondary">Create a campaign</router-link>
                </div>
            </div>
        </div>
    </div>
    <a id="advertisers"></a>
    <div class="advantages">
        <div class="container">
            <div class="advantages__body">
                <h2 class="advantages__title">Ad Operator is taking care of your budget from the first minute<br>Any budget welcome.</h2>
                <div class="advantages__controls">
                    <router-link class="button button--rounded button--small button--primary" to="/signup">create a campaign</router-link>
                </div>
                <div class="advantages__list">
                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <v-lazy-image src="/static/img/advantages-01.svg" alt="advantages-01" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">No bid floor</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <v-lazy-image src="/static/img/advantages-02.svg" alt="advantages-02" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">Smart bidding</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <v-lazy-image src="/static/img/advantages-03.svg" alt="advantages-03" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">Flexible scheduling</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <v-lazy-image src="/static/img/advantages-04.svg" alt="advantages-04" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">CPA Goal</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <v-lazy-image src="/static/img/advantages-05.svg" alt="advantages-05" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">Instant campaign<br />approval</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <v-lazy-image src="/static/img/advantages-06.svg" alt="advantages-06" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">Intuitive UI</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <v-lazy-image src="/static/img/advantages-07.svg" alt="advantages-07" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">IP Blacklist/Whitelist</h3>
                    </div>

                    <div class="advantages__item">
                        <div class="advantages__item__preview">
                            <v-lazy-image src="/static/img/advantages-08.svg" alt="advantages-08" class="advantages__item__preview__img" />
                        </div>
                        <h3 class="advantages__item__name">Google Analytics<br />Support</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="advantages-banner">
        <div class="container">
            <div class="advantages-banner__list">
                <div class="advantages-banner__item">
                    <div class="advantages-banner__item__preview">
                        <v-lazy-image src="/static/img/advantages-banner-01.svg" alt="advantages-banner-01" class="advantages-banner__item__preview__img" />
                    </div>
                    <h3 class="advantages-banner__item__name">Audience</h3>
                    <p class="advantages-banner__item__desc">600.000.000 <br>Real Internet Users</p>
                </div>

                <div class="advantages-banner__item">
                    <div class="advantages-banner__item__preview">
                        <v-lazy-image src="/static/img/advantages-banner-02.svg" alt="advantages-banner-02" class="advantages-banner__item__preview__img" />
                    </div>
                    <h3 class="advantages-banner__item__name">Inventory</h3>
                    <p class="advantages-banner__item__desc">50.000 Publishers</p>
                    <p class="advantages-banner__item__desc">Full Page Ads</p>
                    <p class="advantages-banner__item__desc">Native Ads</p>
                    <p class="advantages-banner__item__desc">CPV Redirects</p>
                </div>

                <div class="advantages-banner__item">
                    <div class="advantages-banner__item__preview">
                        <v-lazy-image src="/static/img/advantages-banner-03.svg" alt="advantages-banner-01" class="advantages-banner__item__preview__img" />
                    </div>
                    <h3 class="advantages-banner__item__name">Performance</h3>
                    <p class="advantages-banner__item__desc">CPA Goal smart <br>bidding technology</p>
                </div>
            </div>
        </div>
    </div>

    <a id="publishers"></a>
    <div class="contact-us">
        <div class="container">
            <div class="contact-us__body">
                <h2 class="contact-us__title">Publishers registration is available by private invitation only.</h2>
                <div class="contact-us__controls">
                    <a id="publisher"></a>
                    <router-link class="button button--rounded button--small button--primary" to="/help/#contact">Contact us</router-link>
                </div>

                <div class="contact-us__preview">
                    <v-lazy-image src="/static/img/contact-us-01.png" alt="contact us" class="contact-us__preview__img" />
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Menu from './menu'

export default {
  name: 'Home',
  components: {
    Menu
  },
  data () {
    return {
      logget: this.$store.getters.isAuthenticated
    }
  },
  head: {
    title: {
      inner: 'Home',
      separator: '-',
      complement: 'Ad Operator'
    },
    meta: [
      {
        name: 'description',
        content: 'Native ads and Push Notifications. You can buy traffic easy. 10% referral comission.'
      },
      {
        name: 'keywords',
        content: ''
      },
      {
        property: 'og:title',
        content: 'Ad Operator'
      },
      {
        property: 'og:image',
        content: 'https://adop.co/static/favicon/android-icon-192x192.png'
      },
      {
        property: 'og:url',
        content: 'https://adop.co/'
      },
      {
        property: 'og:description',
        content: 'Native ads and Push Notifications. You can buy traffic easy. 10% referral comission.'
      }
    ],
    link: [
      {
        rel: 'canonical',
        h: 'https://adop.co',
        id: 'canonical'
      }
    ]
  },
  mounted: function () {
    if (this.$route.fullPath === '/') {
      window.$('html,body').scrollTop(window.$('#home').offset().top)
    }
    if (this.$route.fullPath === '/advertisers') {
      window.$('html,body').scrollTop(window.$('#advertisers').offset().top - 40)
    }
    if (this.$route.fullPath === '/publishers') {
      window.$('html,body').scrollTop(window.$('#publishers').offset().top - 40)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/front/home.vue